export default "__VITE_ASSET__CLdfXp9e__"